import { gql } from "@apollo/client";


export const GET_MATERIAL_LIST = gql`
query getEbookTypes($lId:UUID!) {
  getEbookTypes(libraryid: $lId) {
    nodes {
      typeName
    }
  }
}`;

export const DEFAULT_EBOOKS_TYPES = {
    "data": {
        "getEbookTypes": {
            "nodes": [
                {
                    "typeName": "Materials"
                },
                {
                    "typeName": "Questions bank"
                },
                {
                    "typeName": "Examination Guide"
                }
            ]
        }
    }
}
